import { render } from "./PixelLeaves.vue?vue&type=template&id=2c39747a&scoped=true"
import script from "./PixelLeaves.vue?vue&type=script&lang=js"
export * from "./PixelLeaves.vue?vue&type=script&lang=js"

import "./PixelLeaves.vue?vue&type=style&index=0&id=2c39747a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c39747a"]])

export default __exports__